// bbCardApi.ts

import axios from 'axios';

const REACT_APP_CHATCON_URL = process.env.REACT_APP_CHATCON_URL;

// Define type for engagement parameters
interface CallBBCardPayload {
    [key: string]: any;
    bbc_id: string;
}

// API call to create a crypt request
export const callBBCard = async (payload: CallBBCardPayload): Promise<unknown> => {
    try {
        const { data } = await axios.post(`${REACT_APP_CHATCON_URL}/baseball-create-crypt-request`, {
            contextParameters: payload,
        });
        return data || null;
    } catch (e) {
        console.error("Error calling BB Card API:", e);
        return null;
    }
};
